'use strict';

var sleeknote = sleeknote || {};

sleeknote.listFilter = sleeknote.listFilter || function () {


    function init() {
        // Init functions
        $(document).ready(function(){
            list_filter();
        });
    }

    function list_filter() {
        var options = {
                valueNames: [
                    'post_header',
                    'post_tag',
                    'post_category'
                ]
            },
            post_lists      = document.querySelectorAll('.js-post-list'),
            top_section     = document.getElementById('js-cpt-list-inner');

        if ( post_lists ) {
            for (var i = 0; i < post_lists.length; i++) {
                var this_list = post_lists[i];

                let postList = new List(this_list, options);

                listFunctions(postList);
            }
        }

        function scrollToTop(section) {
            var negative_offset = (window.innerWidth < 992) ? 170 : 126,
                scroll_element = section.offsetTop - negative_offset;

            $([document.documentElement, document.body]).animate({
                scrollTop: scroll_element
            }, 0);
        }

        function listFunctions(postList) {
            function resetList(){
                postList.search();
                postList.filter();
                postList.update();
                $(".filter-all").prop('checked', true);
                $('.filter').prop('checked', false);
                $('.search').val('');
                $('.no-result').hide();
                //console.log('Reset Successfully!');
            };

            $('.post-filter-reset').on('click', function() {
                resetList();

                scrollToTop(top_section);
            });

            var updateList = function() {
                var filter_category_value   = $("input[name=post_category]:checked").val(),
                    filter_tag_value        = $("input[name=post_tag]:checked").val();

                postList.filter(function (item) {
                    var categoryFilter  = false,
                        tagFilter       = false;
                    
                    if (filter_category_value == "all") {
                        categoryFilter = true;
                    } else {
                        categoryFilter = item.values().post_category.indexOf(filter_category_value) >= 0;
                    }

                    if (filter_tag_value == null) {
                        tagFilter = true;
                    } else {
                        tagFilter = item.values().post_tag.indexOf(filter_tag_value) >= 0;
                    }
                    return tagFilter && categoryFilter
                });

                if (filter_category_value == "all") {
                    setTimeout(function() {
                        scrollToTop(top_section);
                    }, 0);
                } else {
                    var current_section = document.getElementById('js-'+filter_category_value);

                    setTimeout(function() {
                        scrollToTop(current_section);
                    }, 0);
                }
                //postList.update();

                if ( $('#js-cpt-list .item').length == 0 ) {
                    $('.no-result').show();

                    setTimeout(function() {
                        scrollToTop(top_section);
                    }, 0);
                } else {
                    $('.no-result').hide();
                }
            }

            $("input[name=post_category]").change(updateList);
            $("input[name=post_tag]").change(updateList);

            $('.search').on('keyup',function(){
                postList.search($('.search').val());

                setTimeout(scrollToTop(top_section), 0);
            });
            
            postList.on('updated', function (list) {
                if (list.matchingItems.length > 0) {
                    list.listContainer.classList.remove('hidden');
                } else {
                    list.listContainer.classList.add('hidden');
                }

                if ( postList.filtered == true || postList.searched == true ) {
                    $('.post-filter-reset').addClass('active');
                } else {
                    $('.post-filter-reset').removeClass('active');
                }
            });
        }


        var filter_section  = document.querySelector('.js-post-filter-section');

        $('.mobile-close-filter-button').on('click', function() {
            if ( filter_section.classList.contains('active') ) {
                filter_section.classList.remove('active');

                scrollToTop(top_section);
            }
        });

        $('.filter-toggle .btn').on('click', function() {
            if ( !filter_section.classList.contains('active') ) {
                filter_section.classList.add('active');
            } else {
                filter_section.classList.remove('active');
            }
        });
    }

    return {
        init:init
    };

}();